import { createGlobalStyle } from '../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { createStyleObject } from '@capsizecss/core';
import { BASE_FONT_SIZE, convertValueToPx, pxToRem } from './remUtils';
import { Rem } from './fontSizeProps';

const {
  featureTextLcRegular,
  featureTextLcRegularItalic,
  graphikBabbelLcgRegular,
  graphikBabbelLcgItalic,
  graphikBabbelLcgSemibold,
  graphikBabbelLcgSemiboldItalic,
} = tokens.asset.font;

export const BabbelFonts = createGlobalStyle`
@font-face {
  font-family: ${tokens.fonts.expressive.name};
  font-style: normal;
  font-weight: 700;
  src: url(${featureTextLcRegular.woff2.url}) format('woff2'),
    url(${featureTextLcRegular.woff.url}) format('woff'),
    url(${featureTextLcRegular.opentype.url}) format('opentype');
  font-display: swap;
}

@font-face {
  font-family: ${tokens.fonts.expressive.name};
  font-style: italic;
  font-weight: 700;
  src: url(${featureTextLcRegularItalic.woff2.url}) format('woff2'),
   url(${featureTextLcRegularItalic.woff.url}) format('woff'),
   url(${featureTextLcRegularItalic.opentype.url}) format('opentype');
  font-display: swap;
}

@font-face {
  font-family: ${tokens.fonts.default.name};
  font-style: normal;
  font-weight: 400;
  src: url(${graphikBabbelLcgRegular.woff2.url}) format('woff2'),
   url(${graphikBabbelLcgRegular.woff.url}) format('woff'),
   url(${graphikBabbelLcgRegular.opentype.url}) format('opentype');
  font-display: swap;
}

@font-face {
  font-family: ${tokens.fonts.default.name};
  font-style: italic;
  font-weight: 400;
  src: url(${graphikBabbelLcgItalic.woff2.url}) format('woff2'),
   url(${graphikBabbelLcgItalic.woff.url}) format('woff'),
   url(${graphikBabbelLcgItalic.opentype.url}) format('opentype');
  font-display: swap;
}

@font-face {
  font-family: ${tokens.fonts.default.name};
  font-style: normal;
  font-weight: 600;
  src: url(${graphikBabbelLcgSemibold.woff2.url}) format('woff2'),
   url(${graphikBabbelLcgSemibold.woff.url}) format('woff'),
   url(${graphikBabbelLcgSemibold.opentype.url}) format('opentype');
  font-display: swap;
}

@font-face {
  font-family: ${tokens.fonts.default.name};
  font-style: italic;
  font-weight: 600;
  src: url(${graphikBabbelLcgSemiboldItalic.woff2.url}) format('woff2'),
   url(${graphikBabbelLcgSemiboldItalic.woff.url}) format('woff'),
   url(${graphikBabbelLcgSemiboldItalic.opentype.url}) format('opentype');
  font-display: swap;
}
`;

// TODO: move to tokens
const fallback = {
  default: 'sans-serif',
  expressive: 'serif',
};

export function fontFamily(type: keyof typeof tokens.fonts = 'default') {
  return { fontFamily: `${tokens.fonts[type].name}, ${fallback[type]}` };
}

export function font({
  type = 'default',
  fontSize = BASE_FONT_SIZE,
  lineHeight,
}: {
  type?: keyof typeof tokens.fonts;
  fontSize?: number | Rem;
  lineHeight?: number | Rem;
}) {
  const convertedFontSize = convertValueToPx(fontSize);
  const convertedLineHeight = lineHeight && convertValueToPx(lineHeight);

  const capsizeStyleObject = createStyleObject({
    fontSize: convertedFontSize,
    leading: convertedLineHeight || convertedFontSize + BASE_FONT_SIZE / 2,
    fontMetrics: tokens.fonts[type].fontMetrics,
  });
  capsizeStyleObject.fontSize = pxToRem(parseFloat(capsizeStyleObject.fontSize));
  capsizeStyleObject.lineHeight = pxToRem(parseFloat(capsizeStyleObject.lineHeight));
  return {
    ...fontFamily(type),
    ...capsizeStyleObject,
  };
}
